import { render, staticRenderFns } from "./NewsAdmin.vue?vue&type=template&id=b3f73c1c&scoped=true"
import script from "./NewsAdmin.vue?vue&type=script&lang=js"
export * from "./NewsAdmin.vue?vue&type=script&lang=js"
import style0 from "./NewsAdmin.vue?vue&type=style&index=0&id=b3f73c1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f73c1c",
  null
  
)

export default component.exports